export const Jr3MediaWorkflow = {
  "id": 101,
  "wfName": "DATG Jellyroll 3 Media",
  "wfDescription": "Automated filenaming and sorting in JR3",
  "wfData": {
    "visible": [
      {
        "section_name": "Files",
        "rows": [
          [
            {
              "id": "files",
              "type": "file_select",
              "label": "Files",
              "width": 12,
              "options": {
                "required": true,
                "min_value": 1,
                "fields": [
                  [
                    {
                      "id": "wmls",
                      "type": "text",
                      "label": "WMLS #",
                      "width": 4,
                      "options": {
                        "required": true,
                        "pattern": "^\\d{7}$"
                      }
                    },
                    {
                      "id": "revision",
                      "type": "text",
                      "label": "Revision",
                      "width": 4,
                      "options": {
                        "pattern": "^\\d*$"
                      }
                    },
                    {
                      "id": "checksum",
                      "type": "text",
                      "label": "MD5 Checksum",
                      "width": 4,
                      "options": {
                        "pattern": "^\\w{32}$"
                      }
                    }
                  ]
                ]
              }
            }
          ]
        ]
      },
      {
        "section_name": "Delivery Info",
        "rows": [
          [
            {
              "id": "destinations",
              "type": "landingpads",
              "label": "Landing Pad",
              "width": 12,
              "options": { }
            }
          ],
          [
            {
              "id": "email",
              "type": "email_list",
              "label": "Email Notifications",
              "width": 12,
              "options": { }
            }
          ],
          [
            {
              "id": "userDelivery",
              "type": "user_list",
              "label": "Direct Delivery",
              "width": 12,
              "options": { }
            }
          ]
        ]
      }
    ],
    "hidden": [
      {
        "id": "priority",
        "type": "select",
        "options": {
          "default": {
            "displayed": "Medium",
            "stored": "2"
          },
          "data": [
            {
              "displayed": "Low",
              "stored": "1"
            },
            {
              "displayed": "Medium",
              "stored": "2"
            },
            {
              "displayed": "High",
              "stored": "3"
            }
          ]
        }
      },
      {
        "id": "jellyroll",
        "type": "select",
        "options": {
          "default": {
            "displayed": "/CNG/INVENTORY TO VERIFY",
            "stored": "0b6ef0ca8030bba5"
          },
          "data": [{
            "displayed": "/CNG/INVENTORY TO VERIFY",
            "stored": "0b6ef0ca8030bba5"
          }]
        }
      }
    ]
  },
  "wfType": "MONORAIL"
}



// WEBPACK FOOTER //
// ./src/app/workflows/jr3-media-workflow.ts